import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getClientActionsListItems = createAsyncThunk(
  "clientActions/getClientActionsListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.loadTrackingAction.getClient();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getClientActionsDetailById = createAsyncThunk(
  "clientActions/getClientActionsDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.clientActions.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const clientActionsSlice = createSlice({
  name: "clientActions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientActionsListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getClientActionsListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getClientActionsListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getClientActionsDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getClientActionsDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getClientActionsDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const {} = clientActionsSlice.actions;
export default clientActionsSlice.reducer;
